import { render, staticRenderFns } from "./changeLanguagePhone.vue?vue&type=template&id=0f8cf2f5&scoped=true"
import script from "./changeLanguagePhone.vue?vue&type=script&lang=js"
export * from "./changeLanguagePhone.vue?vue&type=script&lang=js"
import style0 from "./changeLanguagePhone.vue?vue&type=style&index=0&id=0f8cf2f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8cf2f5",
  null
  
)

export default component.exports